import {storeToRefs} from 'pinia';
import {useRouteParams} from '@vueuse/router';
import {DEFAULT_HYPERMARKET, GLOBAL_BRANCH_SLUG, GLOBUS_HOME_GSOA_ID} from '#shared/constants';
import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';
import type {Branch} from '~/types/branch';

export function useVisitedHypermarket() {
	const {selectedHypermarketInstance, hypermarketsBySlug} = storeToRefs(useStoryblokHypermarketsStore());

	const branch = useRouteParams<string>('branch');

	const visitedHypermarketInstance = computed<Branch | null>(() => {
		if (branch.value) {
			return hypermarketsBySlug.value[branch.value] ?? null;
		}

		return selectedHypermarketInstance.value;
	});

	const houseNumberWithGlobusHomeFallback = computed(() => {
		const slug = !branch.value || branch.value === GLOBAL_BRANCH_SLUG
			? DEFAULT_HYPERMARKET
			: branch.value;
		const gsoaId = hypermarketsBySlug.value[slug]?.content.gsoaId;

		return Number(gsoaId) || GLOBUS_HOME_GSOA_ID;
	});

	return {
		visitedHypermarketInstance,
		houseNumberWithGlobusHomeFallback,
		visitedBranchInstance: visitedHypermarketInstance,
	};
}
